import './Modal.scss';

import { b2x } from '@b2x/react/src';

export type ModalHeaderProps = b2x.ModalHeaderProps;

export const ModalHeader = (props: ModalHeaderProps) => <b2x.ModalHeader {...props} />;
